<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import i18n from "@/i18n";

import { useVideoCallState } from "@/stores/videoCallState";
import { Events, useEventEmitters } from "@events";

const props = defineProps({
  rtcId: {
    type: String,
    required: true,
  },

  // Adding this will prevent a vue.js warning
  sectionType: {
    type: String,
    required: false,
  },

  // Adding this will prevent a vue.js warning
  modelValue: {
    type: Object,
    required: false
  }
});

const state = useVideoCallState(props.rtcId);
const { eventEmitter, actionEmitter } = useEventEmitters(props.rtcId);

const viewScreenshot = ref(false);
const screenshotSrc = ref("");

// when set to true, snackbar is shown for 2 seconds with given text and color
const snackbar = ref(false);
const snackBarText = ref("");
const snackBarColor = ref("");

onMounted(async () => {
  if(state.role == "supervisor") { // When it is supervisor
    eventEmitter.on(Events.SignalingMessageReceived, (data) => {
      if(data.type === "screen-shooter:screenshot-taken"){ // A Response from Agent, that screenshot has been taken
        // Show the screenshot photo
        //console.log("screen-shooter:screenshot-taken", data);

        if(data.screenshotData){
          showSnackbar(i18n.global.t("ScreenshotSuccess"));

          screenshotSrc.value = data.screenshotData;
          viewScreenshot.value = true;
        }
        else {
          showSnackbar(i18n.global.t("ScreenshotFailed"), "red");
        }
      }
    });

    // Prevent downloading the screenshot
    document.addEventListener('contextmenu', preventContextMenu);
  }

  actionEmitter.on("screenshooter-show-snackbar", (data) => {
    showSnackbar(data.text, data.color);
  });
});

// Note: eventEmitter/actionEmitter listeners are auto-cleaned by useEventEmitters on unmount.
// Only the DOM listener needs manual cleanup.
const preventContextMenu = (event) => event.preventDefault();

onUnmounted(() => {
  document.removeEventListener('contextmenu', preventContextMenu);
});

function showSnackbar(text, color = "green") {
  snackbar.value = true;
  snackBarText.value = text;
  snackBarColor.value = color;
}
</script>

<template>
  <v-snackbar :color="snackBarColor" v-model="snackbar" :timeout="2000">
    {{ snackBarText }}

    <template v-slot:actions>
      <v-btn variant="text" @click="snackbar = false">
        {{ $t("Close") }}
      </v-btn>
    </template>
  </v-snackbar>

  <v-dialog class="dialog-content" v-model="viewScreenshot">
    <v-card class="card-content">
      <img class="responsive-image" :src="screenshotSrc" />

      <v-card-text>
        <v-btn color="blue" @click="viewScreenshot = false">{{ $t("Close") }}</v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.dialog-content {
  max-width: 90vw;
}

.card-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.responsive-image {
  max-height: 85vh;
  max-width: 100%;
}
</style>